import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";

import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Exhibitions from "@/pages/Exhibitions";
import LivreOr from "@/pages/LivreOr";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
    return null;
}

function PublicLayout({ children }) {
    return (
        <>
            <Navbar />
            {children}
            <Footer />
            <BackToTop />
        </>
    );
}

function AdminLayout({ children }) {
    return (
        <>
            <Navbar />
            {children}
        </>
    );
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
        let id;
        const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
        id = requestAnimationFrame(raf);
        return () => { cancelAnimationFrame(id); lenis.destroy(); };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <ThemeProvider>
                    <AuthProvider>
                        <ScrollToTop />
                        <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "var(--bg-elev)", border: "1px solid var(--border-strong)", color: "var(--ink)" } }} />
                        <Routes>
                            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                            <Route path="/galerie" element={<PublicLayout><Gallery /></PublicLayout>} />
                            <Route path="/a-propos" element={<PublicLayout><About /></PublicLayout>} />
                            <Route path="/expositions" element={<PublicLayout><Exhibitions /></PublicLayout>} />
                            <Route path="/livre-d-or" element={<PublicLayout><LivreOr /></PublicLayout>} />
                            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
                            <Route path="/admin/login" element={<AdminLayout><AdminLogin /></AdminLayout>} />
                            <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
                        </Routes>
                    </AuthProvider>
                </ThemeProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
